(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/auto-init", [], factory);
	else if(typeof exports === 'object')
		exports["auto-init"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["auto-init"] = factory();
})(this, function() {
return 